import React, { useState, useEffect } from 'react';
import {
  Table,
  Form,
  Col,
  Row,
  FormControl,
  Button,
  Container,
  Badge
} from 'react-bootstrap';
import { BiSearch, BiPlus } from 'react-icons/bi';
import SpinnerComponent from '../layout/spinner';
import { get } from "../../helpers/apiHttp";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import RegistrarContracargo from './RegistrarContracargo';

function GestionarContracargos() {
  const [isLoading, setIsLoading] = useState(false);
  const [stores, setStores] = useState([]);
  const [chargebacks, setChargebacks] = useState([]);

  const [serie, setSerie] = useState("");
  const [searchText, setSearchText] = useState("");

  const [showRegistrar, setShowRegistrar] = useState(false);

  const handleShowRegistrar = () => setShowRegistrar(true);
  const handleCloseRegistrar = () => setShowRegistrar(false);

  const history = useNavigate();

  useEffect(() => {
    fetchStores();
    fetchChargebacks();
  }, []);

/* const fetchStores = async () => {
    try {
      setIsLoading(true);

      const data = await get('risk/stores');

      setIsLoading(false);

      if (data === '401') {
        history("/");
        return;
      }

      if (data.isSuccessful === true && data.statusCode === 200) {
        setStores(data.result || []);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };*/

   const fetchStores  = async () => {
      try {
         let $url='tiendas';
          setIsLoading(true);
          const data = await get($url);
          setIsLoading(false); 
          if (data=='401') {
            history("/");
          }else{
            setStores(data.result);
          }
      } catch (error) {
        setIsLoading(false);
        console.error(error);
      }
    };

  const fetchChargebacks = async () => {
    try {
      setIsLoading(true);

      const url = `risk/chargebacks?serie=${serie}&order_name=${searchText}`;

      const data = await get(url);

      setIsLoading(false);

      if (data === '401') {
        history("/");
        return;
      }

      if (data.isSuccessful === true && data.statusCode === 200) {
        setChargebacks(data.result || []);
      } else {
        setChargebacks([]);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    fetchChargebacks();
  };

  const classificationColor = {
    LEGITIMATE_CHARGEBACK: 'secondary',
    FRAUD_SUSPECTED: 'warning',
    FRAUD_CONFIRMED: 'danger'
  };

  const classificationText = {
    LEGITIMATE_CHARGEBACK: 'Contracargo legítimo',
    FRAUD_SUSPECTED: 'Sospecha de fraude',
    FRAUD_CONFIRMED: 'Fraude confirmado'
  };

  return (
    <>
      {isLoading ? <SpinnerComponent /> : null}

      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h2 className="h2">Gestionar Contracargos</h2>

        <Button variant="success" onClick={handleShowRegistrar}>
          <BiPlus /> Registrar contracargo
        </Button>
      </div>

      <Container fluid className="row pt-3 mb-3">
        <Row>
          <Col></Col>

          <Col>
            <Form.Group className="mb-3">
              <Form.Select
                name="serie"
                value={serie}
                onChange={(e) => setSerie(e.target.value)}
              >
                <option value="">Todas las tiendas</option>
                {stores.map((store) => (
                  <option key={store.id} value={store.prefix}>
                    {store.nombre}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col>
            <Form className="d-flex" onSubmit={handleSearch}>
              <FormControl
                type="search"
                name="search"
                placeholder="Buscar por No Orden"
                className="me-2"
                aria-label="Buscar"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />

              <Button variant="outline-primary" type="submit">
                <BiSearch />
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>

      <div className="container-fluid mb-3">
        <div className="row">
          <div className="table-responsive">
            <Table striped bordered hover className="custom-table table">
              <thead className="table-header">
                <tr>
                  <th>Tienda</th>
                  <th>Serie</th>
                  <th>No Orden</th>
                  <th>Cliente</th>
                  <th>Correo</th>
                  <th>Teléfono</th>
                  <th>Departamento</th>
                  <th>Ciudad</th>
                  <th>Dirección</th>
                  <th>Total</th>
                  <th>Clasificación</th>
                  <th>Fecha Registro</th>
                </tr>
              </thead>

              <tbody>
                {chargebacks.map((item) => (
                  <tr key={item.id}>
                    <td>{item.storeName || item.store_name}</td>
                    <td>{item.serie}</td>
                    <td><b>{item.orderName || item.order_name}</b></td>
                    <td>{item.fullName || item.full_name}</td>
                    <td>{item.email}</td>
                    <td>{item.phone}</td>
                    <td>{item.province}</td>
                    <td>{item.city}</td>
                    <td>{item.address}</td>
                    <td>$ {item.total}</td>
                    <td>
                      <Badge
                        pill
                        bg={classificationColor[item.classification] || 'secondary'}
                        text={item.classification === 'FRAUD_SUSPECTED' ? 'dark' : ''}
                      >
                        {classificationText[item.classification] || item.classification}
                      </Badge>
                    </td>
                    <td>
                      {item.createdAt || item.created_at
                        ? moment(item.createdAt || item.created_at)
                            .locale('es')
                            .format('DD-MMM-YYYY HH:mm:ss')
                        : ''}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>

      <RegistrarContracargo
        show={showRegistrar}
        handleClose={handleCloseRegistrar}
        stores={stores}
        busqueda={fetchChargebacks}
      />
    </>
  );
}

export default GestionarContracargos;